import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class EmailColumn extends Column {
    title = 'payroll.setup.padAgreementLogs.email';
    type = CellDisplay.string;
    property = 'email';
    displayWidth = 25;
}
